import React, { useEffect, useState } from "react";
import {
  DigitalModelForm,
  DigitalModelProps,
} from "../../../types/UploadFieldsType";
import TextInput from "../formComp/TextInputOld";
import SelectInput from "../formComp/SelectInputOld";

const DigitalModel: React.FC<DigitalModelProps> = ({ onChange }) => {
  const [form, setForm] = useState<DigitalModelForm>({
    neededFor: "",
    modelType: "",
    dieRequirement: "",
    otherPreferences: "", // Stored as comma-separated string
    otherSpecifications: "",
  });

  const handleChange = (field: keyof DigitalModelForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    onChange(form);
  }, [form, onChange]);

  const checkboxOptions = [
    "Articulator",
    "Vertex cup attachment",
    "Quadrant",
    "Full arch",
    "Keep palate intact",
  ];

  const selectedPreferences = form.otherPreferences
    ? form.otherPreferences.split(",").map((s) => s.trim())
    : [];

  return (
    <div className="w-full text-sm md:text-lg text-gray-900">
      <h2 className=" font-bold mb-4 border-b-2 border-[#2fa9bf]">
        DIGITAL MODEL
      </h2>

      <div className="w-[100%] md:w-[90%]">
        <SelectInput
          label="Design needed for:"
          name="neededFor"
          value={form.neededFor}
          onChange={(e) => handleChange("neededFor", e.target.value)}
          options={[
            { value: "Simple digital model", label: "Simple digital model" },
            { value: "Ortho study model", label: "Ortho study model" },
            {
              value: "Model for bleaching tray",
              label: "Model for bleaching tray",
            },
          ]}
        />

        <SelectInput
          label="Model type"
          name="modelType"
          value={form.modelType}
          onChange={(e) => handleChange("modelType", e.target.value)}
          options={[
            { value: "Solid", label: "Solid" },
            { value: "Hollow", label: "Hollow" },
          ]}
        />

        <SelectInput
          optional
          label="Die requirement"
          name="dieRequirement"
          value={form.dieRequirement}
          onChange={(e) => handleChange("dieRequirement", e.target.value)}
          options={[
            {
              value: "Unsectioned model without die",
              label: "Unsectioned model without die",
            },
            {
              value: "Unsectioned model with separate die",
              label: "Unsectioned model with separate die",
            },
            {
              value: "Unsectioned model with margin ditched",
              label: "Unsectioned model with margin ditched",
            },
            {
              value: "Unsectioned model with margin ditched without die",
              label: "Unsectioned model with margin ditched without die",
            },
            {
              value: "Unsectioned model with margin ditched with separate die",
              label: "Unsectioned model with margin ditched with separate die",
            },
            {
              value: "Sectioned model with removable die",
              label: "Sectioned model with removable die",
            },
          ]}
        />

        <div className="my-4 flex">
          <label className="block font-normal w-[36%]">
            Other preferences{" "}
            <span className="text-gray-400 text-sm">(Optional)</span>
            <div className="text-sm">
              Please select all that apply
            </div>
          </label>
          <div className="grid w-auto grid-cols-1 gap-x-8 gap-y-2 mt-2">
            {checkboxOptions.map((option) => {
              const isChecked = selectedPreferences.includes(option);

              return (
                <label key={option} className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    value={option}
                    checked={isChecked}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      let updatedPreferences: string[];

                      if (checked) {
                        updatedPreferences = [...selectedPreferences, option];
                      } else {
                        updatedPreferences = selectedPreferences.filter(
                          (item) => item !== option
                        );
                      }

                      setForm((prev) => ({
                        ...prev,
                        otherPreferences: updatedPreferences.join(", "),
                      }));
                    }}
                  />
                  <span>{option}</span>
                </label>
              );
            })}
          </div>
        </div>

        <TextInput
          optional
          label="Other specifications"
          name="otherSpecifications"
          value={form.otherSpecifications}
          onChange={(e) => handleChange("otherSpecifications", e.target.value)}
        />
      </div>
    </div>
  );
};

export default DigitalModel;
